export default "/img/MC.059a68c34e531c8a5da859cafe4bcb5d.png";